module.exports = __webpack_public_path__ + "static/media/date-icon.e1016a92.svg";